import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	createResource,
	type ResourceStoreContext,
	type RouterDataContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_USER_HOMEPAGE } from '../common/constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userHomepageResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_USER_HOMEPAGE,
	getKey: () => 'state',
	getData: async (_dataContext: RouterDataContext, _storeContext: ResourceStoreContext) => {
		const { homepagePreference } = await performGetRequest('/rest/internal/3/homepage/');

		return { homepagePreference };
	},
	maxAge: Infinity,
	isCritical: true,
});
